export default __webpack_public_path__ + "static/media/rtcc_bg_000.1d3399ed.jpg";